import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CompanyMyNotaryEntityState } from '@_model/interfaces/company-my-notary.model';

export interface CompanyMyNotaryState extends EntityState<CompanyMyNotaryEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<CompanyMyNotaryEntityState> = createEntityAdapter<CompanyMyNotaryEntityState>({
  selectId: o => o.idCompanyMyNotary
});
export const initialState: CompanyMyNotaryState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const companyMyNotaryFeatureKey = 'companyMyNotary';
